import React, { useMemo } from 'react';
import { useFeatureFlag } from '@americanexpress/one-experiments';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { useSelector } from 'react-redux';
import { ClickToChat as ClickToChatAskAmexScript } from '@americanexpress/shared-scripts';
import getSafeLocaleData from '../../utils/getSafeLocaleData';
import { isStrategicInitiativeRule } from '../../constants/featureConstants';
import { CLICK_TO_CHAT_FEATURE_FLAG } from '../../constants/oneExperimentConstants';

const ClickToChat = () => {
  const locale = useSelector(getActiveLocaleSelector);
  const isHorizons = useConditionalFeature(isStrategicInitiativeRule);
  const { enabled, properties } = useFeatureFlag({ featureFlagName: CLICK_TO_CHAT_FEATURE_FLAG });

  const isEnabledByFeatureFlag = !!(enabled && (properties?.[locale] === 'true'));
  const hasClickToChat = useMemo(() => isHorizons || isEnabledByFeatureFlag,
    [isHorizons, isEnabledByFeatureFlag]);

  if (hasClickToChat) {
    return (
      <ClickToChatAskAmexScript
        version="^1.0.0"
        market={getSafeLocaleData(locale)?.country}
        locale={locale}
        lineOfBusiness="Travel"
      />
    );
  }
  return null;
};

export default ClickToChat;
